import { StyledTraslados } from "../../../../styled/traslados";
import PendientesATTable from "./pendientesATTable";
import PendientesGSTable from "./pendientesGSTable";

const PendientesTraslados = ({
  showAgente,
  showGestor,
  showTabs,
  selectedView,
  onChangeView,
  pendientesData,
  onRefresh,
  onVisualizarSiniestro,
  onVisualizarTrasladoAt,
  onVisualizarTrasladoGs,
  onAuditarTraslado,
}) => {
  return (
    <>
      {showTabs && (
        <StyledTraslados.Tabs
          value={selectedView}
          onChange={onChangeView}
          textColor="primary"
          indicatorColor="primary">
          {showAgente && (
            <StyledTraslados.Tab value="at" label="Agente de Traslados" />
          )}
          {showGestor && (
            <StyledTraslados.Tab value="gs" label="Gestor de Siniestros" />
          )}
        </StyledTraslados.Tabs>
      )}
      {selectedView === "gs" ? (
        <PendientesGSTable
          data={pendientesData?.data?.pendientesGS || []}
          idReferenteUsuario={pendientesData?.data?.idReferenteUsuario}
          onRefresh={onRefresh}
          onVisualizarSiniestro={onVisualizarSiniestro}
          onVisualizarTraslado={onVisualizarTrasladoGs}
          onAuditarTraslado={onAuditarTraslado}
          isLoading={pendientesData?.isFetching}
        />
      ) : (
        <PendientesATTable
          data={pendientesData?.data?.pendientesAT || []}
          onRefresh={onRefresh}
          isLoading={pendientesData?.isFetching}
          onVisualizarSiniestro={onVisualizarSiniestro}
          onVisualizarTraslado={onVisualizarTrasladoAt}
          onAuditarTraslado={onAuditarTraslado}
        />
      )}
    </>
  );
};

export default PendientesTraslados;
